export default {
  pt: {
    'shipments.lancarCargas.titulo': 'Lançar cargas atendidas',
    'shipments.lancarCargas.solicitadas_one': '{{count, number}} carga solicitada',
    'shipments.lancarCargas.solicitadas_other': '{{count, number}} cargas solicitadas',
    'shipments.lancarCargas.atendidas': 'Cargas atendidas',
    'shipments.lancarCargas.atendidasAjuda': 'Deixe em branco para desfazer o lançamento.',
    'shipments.lancarCargas.justificativa': 'Justificativa',
    'shipments.lancarCargas.justificativaObrigatoria': 'Justificativa (obrigatória)',
    'shipments.lancarCargas.justificativaAjuda': 'Opcional: o atendido alcançou o solicitado.',
    'shipments.lancarCargas.justificativaAjudaObrigatoria': 'O atendido ficou abaixo do solicitado.',
    'shipments.lancarCargas.error.quantidade': 'Informe um número inteiro de cargas, zero ou mais.',
    'shipments.lancarCargas.error.justificativa': 'Informe a justificativa.',
    'shipments.lancarCargas.salvando': 'Lançando...',
    'shipments.lancarCargas.salvo': 'Cargas atendidas lançadas.',
    'shipments.lancarCargas.desfeito': 'Lançamento desfeito.',
  },
  en: {
    'shipments.lancarCargas.titulo': 'Record attended loads',
    'shipments.lancarCargas.solicitadas_one': '{{count, number}} load requested',
    'shipments.lancarCargas.solicitadas_other': '{{count, number}} loads requested',
    'shipments.lancarCargas.atendidas': 'Attended loads',
    'shipments.lancarCargas.atendidasAjuda': 'Leave blank to undo the record.',
    'shipments.lancarCargas.justificativa': 'Reason',
    'shipments.lancarCargas.justificativaObrigatoria': 'Reason (required)',
    'shipments.lancarCargas.justificativaAjuda': 'Optional: attended met the request.',
    'shipments.lancarCargas.justificativaAjudaObrigatoria': 'Attended fell short of the request.',
    'shipments.lancarCargas.error.quantidade': 'Enter a whole number of loads, zero or more.',
    'shipments.lancarCargas.error.justificativa': 'Enter the reason.',
    'shipments.lancarCargas.salvando': 'Recording...',
    'shipments.lancarCargas.salvo': 'Attended loads recorded.',
    'shipments.lancarCargas.desfeito': 'Record undone.',
  },
  es: {
    'shipments.lancarCargas.titulo': 'Registrar cargas atendidas',
    'shipments.lancarCargas.solicitadas_one': '{{count, number}} carga solicitada',
    'shipments.lancarCargas.solicitadas_other': '{{count, number}} cargas solicitadas',
    'shipments.lancarCargas.atendidas': 'Cargas atendidas',
    'shipments.lancarCargas.atendidasAjuda': 'Deje en blanco para deshacer el registro.',
    'shipments.lancarCargas.justificativa': 'Justificación',
    'shipments.lancarCargas.justificativaObrigatoria': 'Justificación (obligatoria)',
    'shipments.lancarCargas.justificativaAjuda': 'Opcional: lo atendido alcanzó lo solicitado.',
    'shipments.lancarCargas.justificativaAjudaObrigatoria': 'Lo atendido quedó por debajo de lo solicitado.',
    'shipments.lancarCargas.error.quantidade': 'Indique un número entero de cargas, cero o más.',
    'shipments.lancarCargas.error.justificativa': 'Indique la justificación.',
    'shipments.lancarCargas.salvando': 'Registrando...',
    'shipments.lancarCargas.salvo': 'Cargas atendidas registradas.',
    'shipments.lancarCargas.desfeito': 'Registro deshecho.',
  },
}
